import { EventEmitter } from "@baseline/runtime/events";
import { View } from "./view";


export class ViewController implements View
{
    constructor()
    {
    }

    on(event: "update", handler: (view: View) => void): this
    {
        this.emitter.on(event, handler);
        return this;
    }

    off(event: "update", handler: (view: View) => void): this
    {
        this.emitter.off(event, handler);
        return this;
    }

    get isVisible(): boolean
    {
        return this.#isVisible;
    }

    set isVisible(visible: boolean)
    {
        if (visible != this.#isVisible)
        {
            this.#isVisible = visible;
            this.emitter.emit("update");
        }
    }


    private emitter = EventEmitter.create();
    #isVisible: boolean = false;
}


export namespace ViewController
{
    export function create<T extends Record<string, View>>(innerViews?: T): ViewController & T
    {
        const viewController = new ViewController();

        if (innerViews)
        {
            Object.values(innerViews)
                .forEach(
                    view => view.parent = viewController
                );
        }

        return (
            (innerViews)
                ? Object.assign(viewController, innerViews)
                : viewController as ViewController & T
        );
    }
}
